import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {EditorState, convertToRaw, ContentState, Modifier} from 'draft-js';
import React, {useCallback, useEffect, useState} from "react";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from "html-to-draftjs";
import {Source} from "../repository/Article.repo";
import {Button, TextField} from "@mui/material";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
const SAlert = withReactContent(Swal)

interface IHTMLEditor {
    value: string;
    onChange: (data: any) => void;
    sources: Source[];
    onSourceAdd: (source:Source) => void;
    onSourceChange: (source: Source[]) => void;
}

function HTMLEditorData(props: IHTMLEditor) {
    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty());


    useEffect(() => {
        setEditorState(props.value)
        // const contentBlock = htmlToDraft(props.value);
        // if (contentBlock) {
        //     const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        //     const editorState = EditorState.createWithContent(contentState);
        //     setEditorState(editorState);
        // }
    }, [props.value]);


    const keepSourcesDeleteNumbersInContent = useCallback((data: number[], close?: boolean) => {

        let getEditorState = editorState.getCurrentContent();

        getEditorState = draftToHtml(convertToRaw(getEditorState));
        console.log(getEditorState);
        data.forEach((number) => {
            getEditorState = getEditorState.replace(`<sup>${number}</sup>`, '');
        });

        const contentBlock = htmlToDraft(getEditorState);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorStateData = EditorState.createWithContent(contentState);
            setEditorState(editorStateData);
            props.onChange(editorStateData);
        }

        if(close){
            SAlert.close();
        }


    }, [editorState]);

    const deleteNotPresentSources = useCallback((sources: Source[], notFound: number[], close?: boolean) => {

        const filteredSources = sources.filter((source) => !notFound.includes(source.Number));

        props.onSourceChange(filteredSources);

        if(close){
            SAlert.close();
        }

    }, [props.onSourceChange]);


    const sortSourceNumbers = useCallback((sources: Source[], matches: number[], close?: boolean) => {
        let getEditorState = editorState.getCurrentContent();
        let editedData = '';
        getEditorState = draftToHtml(convertToRaw(getEditorState));
        const newSourceMap: Source[] = [];
        const regex = /<sup>(.*?)<\/sup>/gi;
        const matchData: string[] = getEditorState.match(regex);
        matchData.forEach((matchItem, index) => {
            console.log(matchItem);
            const findSource = sources.find((sourceItem) => {
                return sourceItem.Number === Number(matchItem.replace('<sup>', '').replace('</sup>', ''));
            });
            if(findSource){
                newSourceMap.push({
                    Number: index + 1,
                    ID: findSource.ID,
                    Url: findSource.Url
                });

            }else{
                newSourceMap.push({
                    Number: 99 + index,
                    ID: 99 + index + Number((Math.random().toFixed(4))),
                    Url: ''
                });
            }


            getEditorState = getEditorState.replace(matchItem, `<sup>${index + 1}</sup>`);
            const getEditorStateSplit = getEditorState.split(`<sup>${index + 1}</sup>`);
            console.log(getEditorStateSplit);
           if(getEditorStateSplit[0] !== undefined){
               editedData += getEditorStateSplit[0] + `<sup>${index + 1}</sup>`;
               delete getEditorStateSplit[0];
               if(matchData.length === index + 1){
                   editedData += getEditorStateSplit.join('');
               }
               getEditorState = getEditorStateSplit.join('');
           }
        });

        const contentBlock = htmlToDraft(editedData);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorStateData = EditorState.createWithContent(contentState);
            setEditorState(editorStateData);
            props.onChange(editorStateData);
            props.onSourceChange(newSourceMap);
        }

        if(close){
            SAlert.close();
        }

    }, [editorState, props]);


    const syncEverything = useCallback( (sources: Source[], notFound: number[], foundInHTMLNotInSource: number[], matches: number[]) => {

        deleteNotPresentSources(sources, notFound, false);
        keepSourcesDeleteNumbersInContent(foundInHTMLNotInSource, false);
        sortSourceNumbers(sources, matches, false);

        SAlert.close();


    }, [deleteNotPresentSources, keepSourcesDeleteNumbersInContent, sortSourceNumbers]);

    const htmlAlertData = useCallback((notFound: number[], foundInHTMLNotInSource: number[], matches: number[]) => {

        return (
            <div>
                {notFound.length > 0 && "Sources found but not assigned in content:"}
                <ul>
                    {notFound.map(number => (
                        <li>{number}</li>
                    ))}
                </ul>

                {foundInHTMLNotInSource.length > 0 && "Source deleted but found in content"}
                <ul>
                    {foundInHTMLNotInSource.map(number => (
                        <li>{number}</li>
                    ))}
                </ul>

                <div onClick={() => syncEverything(props.sources, notFound, foundInHTMLNotInSource, matches)} className="backButton" style={{width: '100%', marginTop: 20}}>
                    Sync Everything
                </div>
                <div onClick={() => deleteNotPresentSources(props.sources, notFound, true)} className="backButton" style={{width: '100%'}}>
                    Delete not present sources
                </div>
                <div onClick={() => keepSourcesDeleteNumbersInContent(foundInHTMLNotInSource, true)} className="backButton" style={{width: '100%'}}>
                    Delete not assigned numbers in content
                </div>
                <div onClick={() => sortSourceNumbers(props.sources, matches, true)} className="backButton" style={{width: '100%'}}>
                    Reassign numbers only
                </div>

                <div onClick={() => SAlert.close()} className="backButton" style={{width: '100%'}}>
                    Cancel
                </div>

            </div>
        )

    }, [props.sources, deleteNotPresentSources, sortSourceNumbers, keepSourcesDeleteNumbersInContent])


    const lookForChangesAndSetDescription = useCallback(() => {
        let descriptionData = editorState;
        let convertedData = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        const regex = /<sup>(.*?)<\/sup>/gi;
        if(props.sources.length > 0){
            const notFound: number[] = [];
            const foundInHTMLNotInSource: number[] = [];
            let matches: string[] | number[] | null = convertedData.match(regex);
            if(matches !== null){
                matches = matches.map((id: string) => {
                    return Number(id.replace('<sup>', '').replace('</sup>', ''));
                })

                if(matches !== null){
                    props.sources.forEach((item) => {
                        // @ts-ignore
                        const match = matches.findIndex((matchItem) => matchItem === item.Number);
                        if(match === -1){
                            notFound.push(item.Number);
                        }
                    });
                }

                if(matches !== null){
                    matches.forEach((item) => {
                        const findSource = props.sources.findIndex((source) => source.Number === item);
                        if(findSource === -1){
                            foundInHTMLNotInSource.push(item);
                        }
                    })
                }

                SAlert.fire({
                    title: "Sources will be changing",
                    html: htmlAlertData(notFound, foundInHTMLNotInSource, matches),
                    showConfirmButton: false,
                })
                console.log(notFound, foundInHTMLNotInSource);
            }
        }
        //console.log(descriptionData);


    }, [editorState, props.sources, htmlAlertData]);





    const Sync = useCallback(() => {

        return (
            <div className="rdw-image-wrapper" aria-label="rdw-block-control" role="button" >
                <div className="rdw-option-wrapper" onClick={lookForChangesAndSetDescription}>
                    <span>Sync Sources</span>
                </div>
            </div>
        )

    }, [lookForChangesAndSetDescription]);

    return (
        <Editor
            wrapperClassName="demo-wrapper"
            editorClassName="demo-editor"
            toolbarClassName="toolbarClassName"
            editorState={editorState}
            toolbarCustomButtons={[<Replacements sources={props.sources} onSourceAdd={props.onSourceAdd} />, <Sync />]}
            onEditorStateChange={(state) => {
                setEditorState(state);
                props.onChange(state)
            }}

        />
    );
};




function AddSourceItem(props: any): any {

    const addStar = (): void => {
        const { editorState, onChange } = props;

        const insertNumberFirst = Modifier.replaceText(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            '1',
            editorState.getCurrentInlineStyle()
        );

        const contentState = Modifier.applyInlineStyle(
            editorState.getCurrentContent(),
            editorState.getSelection(),
            'SUPERSCRIPT',
        );

        onChange(EditorState.push(editorState, contentState, 'insert-characters'));
    };

    return (<div onClick={addStar}>⭐</div>);
}


type ReplacementsProps = {
    onChange?: (editorState: EditorState) => void,
    editorState: EditorState,
}


export const Replacements = (props: any) => {
    const [open, setOpen] = useState<boolean>(false);
    const [url, setUrl] = useState('');
    const nextSourceKey = props.sources.length > 0 ? (Math.max(...props.sources.map((source:any) => source.Number)) + 1) : 1;
    const addPlaceholder = (): void => {
        const contentState = Modifier.replaceText(
            props.editorState.getCurrentContent(),
            props.editorState.getSelection(),
            nextSourceKey.toString(),
            props.editorState.getCurrentInlineStyle().add('SUPERSCRIPT'),
        )
        const result = EditorState.push(props.editorState, contentState, 'insert-characters');
        if (props.onChange) {
            props.onChange(result);
        }
        props.onSourceAdd({
            ID: nextSourceKey,
            Url: url,
            Number: nextSourceKey
        });
        setUrl('');
        setOpen(false);
    };
    return (
        <div className="rdw-image-wrapper" aria-label="rdw-block-control" role="button" tabIndex={0}>
                <div className="rdw-option-wrapper" onClick={() => setOpen(!open)}>
                    <span>Add Source</span>
                </div>
                <div className={`rdw-image-modal ${open ? '' : 'placeholder-ul'}`} style={{width: 300, display: "flex", justifyContent: "center", flexDirection: "row", alignItems: "center"}}>
                    <TextField placeholder="Url" size="small" value={url} defaultValue={url} onChange={(e) => setUrl(e.target.value)} />
                    <button className="rdw-embedded-modal-btn" onClick={addPlaceholder}>Add</button>
                </div>
        </div>
    );
};



export const HTMLEditor = React.memo(HTMLEditorData);
